var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"elevation-0 pa-0",staticStyle:{"height":"100%"},attrs:{"id":"chatConatiner"}},[_c('Chat',{attrs:{"id":_vm.id,"userName":_vm.userName,"getMessages":_vm.getMessages,"sendMessage":_vm.sendMessage,"shown":_vm.shown}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }